/** @jsx jsx */
import { Box, Flex, jsx } from "theme-ui";
import { useState, useMemo, useEffect } from "react";
import {
  useSrcmApiStore,
  useFetchSrcmApi,
} from "gatsby-plugin-hfn-profile/fetch-srcm-api";
import { IndexWithRouter } from "@heartfulnessinstitute/react-hfn-forms/dist/ui/CrudTemplate";
import useAuth from "gatsby-plugin-hfn-profile/auth/useAuth";
import { selectorFirebaseAuthProfile } from "gatsby-plugin-hfn-profile/state/selectors";
import { isLoaded } from "react-redux-firebase";
import { useSelector } from "react-redux";
// import { DefaultButton } from "office-ui-fabric-react";
// import { navigate } from "@reach/router";
import PropTypes from "prop-types";
// import { buttonStyles } from "sites-common/utils/fabricStyles";
import { get } from "lodash";
import Dashboard from "./Dashboard";
import Config from "./Config";

// const goBack = () => navigate(-1);

function useConfig(uri) {
  const profile = useAuth();

  const loggedUser = useMemo(
    () => ({
      id: get(profile, "srcmProfile.id"),
      name: get(profile, "srcmProfile.name"),
    }),
    [profile]
  );

  const formDefaults = useMemo(
    () => ({
      ...Config.formDefaults,
      organizers: [loggedUser],
      ...(get(profile, "srcmProfile.city")
        ? {
            venue_city: {
              id: get(profile, "srcmProfile.city_id"),
              name: get(profile, "srcmProfile.city"),
            },
          }
        : {}),
      ...(get(profile, "srcmProfile.srcm_group")
        ? {
            srcm_group: {
              id: get(profile, "srcmProfile.srcm_group_id"),
              name: get(profile, "srcmProfile.srcm_group"),
            },
          }
        : {}),
    }),
    [profile, loggedUser]
  );

  const srcmstoreDb = useSrcmApiStore(Config.collection, {
    api: "/api/v3/events/",
    primaryKey: Config.primaryKey,
    client: "eventsClient",
    methodParams: {
      reporting_only: null,
    },
  });

  const myConfig = {
    ...Config,
    formDefaults,
    db: srcmstoreDb,
    homeUrl: () => uri,
  };
  return myConfig;
}

function Main(props) {
  const { uri, location } = props;
  const myConfig = useConfig(uri);
  const auth = useSelector(selectorFirebaseAuthProfile);
  const authLoaded = isLoaded(auth);
  const OtherRoutes = [<Dashboard path={`${uri}/:eventName/dashboard`} />];
  const { fetchSrcmApi } = useFetchSrcmApi();
  const [tags, setTags] = useState([]);
  useEffect(() => {
    fetchSrcmApi({
      api: `/api/v3/event-tags/`,
      client: "eventsClient",
    }).then((data) => {
      const tagsList = data.results.map((r) => ({
        name: r.name,
        label: r.name,
      }));
      setTags(tagsList);
    });
  }, [fetchSrcmApi]);

  myConfig.formFields = myConfig.formFields.map((p) =>
    p.name === "tag_strings" ? { ...p, options: tags } : { ...p, options: [] }
  );

  return (
    <Box sx={{ p: 2, mb: 4 }}>
      <Flex sx={{ my: 2 }}>
        <Box sx={{ fontSize: 3, fontWeight: "medium", flex: "1 1 auto" }}>
          {location.pathname === `${uri}/new` && "Add Event"}
        </Box>
        <Box>
          {/* <DefaultButton
            styles={buttonStyles.default}
            iconProps={{ iconName: "Back" }}
            text="Back"
            onClick={goBack}
          /> */}
        </Box>
      </Flex>

      {authLoaded && (
        <IndexWithRouter Config={myConfig} OtherRoutes={OtherRoutes} />
      )}
    </Box>
  );
}

Main.defaultProps = {
  uri: "",
  location: {},
};

Main.propTypes = {
  uri: PropTypes.string,
  location: PropTypes.objectOf(PropTypes.any),
};

export default Main;
